module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud2_v2.e6836738a456825b54d969786ea45867.png";